import { PurchaseList } from './PurchaseList';
import { PurchaseCreate } from './PurchaseCreate';
import { PurchaseEdit } from './PurchaseEdit';

export default {
  list: PurchaseList,
  create: PurchaseCreate,
  edit: PurchaseEdit,
};
